import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private apiUrl = `${environment.apiUrl}/country`; // API URL'yi güncelliyoruz

  constructor(private http: HttpClient) {}
  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }
}
